import * as constants from "./constants";

export const initialTagModel = {
    [constants.TITLE_RU]: '',
    [constants.TITLE_EN]: '',
    [constants.COLOR]: constants.DEFAULT_COLOR,
};

export const initialPartnerModel = {
    [constants.LOGO_URL]: '',
    [constants.LINK]: '',
    [constants.TITLE_RU]: '',
    [constants.TITLE_EN]: '',
};

export const initialFileModel = {
    [constants.FILE]: null,
    [constants.LINK]: '',
    [constants.TITLE_RU]: '',
    [constants.TITLE_EN]: '',
    [constants.EXTENSION]: null,
};

export const availableTypes = {
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/pdf': 'pdf',
    'application/vnd.ms-powerpoint': 'pptx',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'image/png': 'png',
    'image/jpeg': 'jpeg',
    'image/jpg': 'jpg',
    'image/bmp': 'bmp',
    'image/heif': 'heif',
    'image/heic': 'heic',
};
